import { render, staticRenderFns } from "./PostModal.vue?vue&type=template&id=7fe52929&"
import script from "./PostModal.vue?vue&type=script&lang=js&"
export * from "./PostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports